export default {
    detail:{
        activite:'Activity detail',
        mission:'Detail of the missions',
    },
    information:{
        generale:'General information',
        mission:'Detailed information'
    },
     mobile: {
        prestataire : 'Medical providers',
        etablissement : 'Establishments',
    },
    cloture:'Closed ',
    cloturer:'Close ',
    missionCloture:'Is this mission Closed ?',
    activiteCloture:'Is this activity Closed ?',
    details:'Detail | Details',
    dateCloture:'Closing date',
    commentaires:'Comment | Comments',
    groupeActivite:'Activity group',
    activite:{
        mission:{
            update:'Mission updated',
            add:'Mission added',
            delete:'Mission deleted',
        },
        cloture:'Activity closed',
        create:'Activity created',
        delete:'Activity deleted',
        edit:'Activity edited',
        titre:'Activity  | Activities',
        nom:'Name of the activity',
        0: 'Affiliate Patient Tracking Process',
        1: 'Affiliated Patient Follow-up Process - HOT Medicasure (J1)',
        2: 'Follow-up process of an Affiliated Patient - Medicasure in COLD   (After the acute event with the exception of home consultations)',
        3: 'Network Expansion - Medicasure Partner and Quality Control',
        4: 'Scientific promotion',
    },
    compteRendu:{
        operatoireCreated:'Recorded operating report',
        operatoireDeleted:'Operating report deleted',
        operatoireUpdated:'Modified operating report',
        operatoireTransmit:'Transmitted operative report',
        operatoireArchive:'Archived operative report',
        operatoireReactiver:'Operatory report reactivated',
    },
    traitementPostOperatoire:'Post-operative treatment',
    addCompteRenduOp: 'Ajouter Un Compte Rendu Opératoire',
    addPrescrip: 'Ajouter Une Prescription',
    addLabResults: 'Ajouter Un Résultat de Laboratoire',
    descriptionIntervention:'Description of the intervention',
    typeAnesthesie:'Type of anaesthetist',
    editGeneratlConsul: 'Modifier Une Consultation Médecine Générale',
    circulant:'Circulating',
    anesthesistes:'Anaesthetist(s)',
    aide:'Help(s)',
    chirugiens:'Surgeon(s)',
    etablissementIntervention:'Intervention establishment',
    typeIntervention:'Type of intervention',
    dateIntervention:'Date of intervention',
    prestationValide:'Validated service',
    prestationRejete:'Service rejected',
    decede:'Deceased',
    nonDecede:'Not Deceased',
    patientDecede:'Patient deceased',
    cePatientEstDecede:'Is this person deceased ? ',
    cePatientNEstDecede:'You want to change the status of this patient ',
    importPrtestation:'Import services',
    imprimerProforma:'Print a proforma',
    imprimerDefinitive:'Print a final invoice',
    comptableCreated: 'Accountant created successfully',
    assistanteCreated: 'Assistante created successfully',
    comptableUpdated: 'Accountant updated successfully',
    assistanteUpdated: 'Assistante updated successfully',
    comptableDeleted: 'Accountant deleted successfully',
    assistanteDeleted: 'Assistante deleted successfully',
    infoGenerale:'General Invoice Information',
    rappeler:'Call back',
    institution:'Institution',
    homme:'Man',
    femme:'Woman',
    isComptable:'Is he an accountant ?',
    userNotFound:'You can\'t find the user',
    mailEnvoye:'Mail sent',
    recouvrer:'Recover',
    modifierFacture:'Edit invoice',
    totalPrixPrestation:'Total price for the service',
    detailsFacture:'Invoice details',
    detailsPrestation:'Prestation details',
    ajouterDetail:'Add details',
    enregistrerFacture:'Save invoice',
    facture:'Invoice | Invoices',
    facturations:'Invoice | Invoices',
    EtablissementPrix:'Institution price',
    facture:'Invoices',
    facturations:'Invoices',
    amount: 'Amount',
    dateFacturation:'Invoice date',
    datePrestation:'Prestation date',
    ajouterALaListeDesFactures:'Add prestation to the list of services',
    totalHorsRemise:'Total excluding discount',
    totalAvecRemise:'Total with discount',
    remise:'Discount',
    continuer:'Continue',
    factureCreated: 'Invoice created successfully',
    AssignCreated: 'Assign created successfully',
    factureUpdated: 'Invoice updated successfully',
    factureDeleted: 'Invoice deleted successfully',
    nomEtablissement:'Name of establishment',
    nomPrestation:'Name of the prestation',
    reduction:'Reduction',
    listeDesEtablissements:'List of establishments offering this service',
    nonDefinie:'Not define',
    nomDeLaCategorie:'Category Name',
    aucun:'None | None',
    autre:'Other | Other',
    addAutrePrestation:'Add other services',
    addAutreCategorie:'Add other category',
    categoriePrestation:'Categories of prestation',
    prestationCreated: 'Prestation created successfully',
    prestationUpdated: 'Prestation updated successfully',
    prestationDeleted: 'Prestation deleted successfully',
    categorieCreated: 'Category created successfully',
    categorieUpdated: 'Category updated successfully',
    categorieDeleted: 'Category deleted successfully',
    listeDesPrestations:'List of services',
    prestation:'Prestation | Prestations',
    prestationDetail:'Prestations details',
    prestationEtablissement:'Establishment services',
    comptable:'Accountant',
    consultationExiste:'you don\'t find your type of consultation in the list above',
    praticienExiste:'You do not find the practitioner in the list above',
    consultationName:'Consulation name / Prestation name',
    organiserRdv:'Would you like to schedule an appointment for this patient ?',
    fichiersExternes:'External medical files',
    compteRenduOperatoire:'Operating report',
    deleteLogo:'Delete logo',
    manuscrit:'External file',
    tailleMaximum:'Maximum upload file size : 7 MB. You can reduce the size of your files on this site:' +
        'https://www.wecompress.com/',
    userIsNotice:'is it practitioner\'s opinion ?',
    adresse:"Address",
    rapport:"Report",
    dateFin:'Stop date',
    voieAdmin:'Route of administration',
    par:'Per',
    nombre:'Number',
    nomDci:'International non-proprietary name',
    nomSpecialite:'Brand name',
    infoComp:'Complementary data',
    formulation:'Formulation',
    dose:'Dose',
    indicatif:'Telephone code',
    all:'All',
    addAll:'Add all',
    filtered:'Filtered',
    filter:'Search a diagnostic in English',
    answer:'Answer',
    secretQuestion:'Secret question',
    alreadySend:'SMS already sent',
    shallBeGenerate:'A new password shall be generate and sent by SMS.',
    smsSended:"SMS sended",
    labelLogin:"Numero de dossier ou email",
    listOfSubscribers:"List of subscribers",
    uploadSignature:"Upload signature",
    isMedPatner:'Is it a attached to Medicasure ?',
    abdoPerimetre:"Abdominal circumference",
    cardiacExam:"Heart  examination",
    cardiacExamAdd:"Heart  examination add successfully",
    cardiacExamCreated: 'Heart  examination created successfully',
    cardiacExamUpdated: 'Heart  examination updated successfully',
    cardiacExamDeleted: 'Heart  examination successfully deleted',
    abdominalPerimeter:'Périmètre abdominal (cm)',
    changeRole:'Change de role',
    fileDeleted:"File successfully deleted",
    maxFileSize:"Maximum file size 5 Mo",
    addImageryRes: 'Ajouter Un Résultat d\'Imagerie',
    addHospitalisation: 'Ajouter Une Hospitalisation',
    addManuscritConsul: 'Ajouter Un Fichier Externe',
    listMedecinControl: "LISTE PATIENT & MEDECIN RÉFERENT",
    areYouSure:'Are you sure ?',
    takeCare: "Care and Support",
    yesLeave:'Yes, leave the page',
    unsaveData:'Unsaved data will be lost',
    disconnectMessage:'Disconnected due to inactivity on the site',
    tradeName:'Trade name',
    activeSubstance:'Active substance',
    therapeuticClass:'Therapeutic class',
    dosage:'Form and dosage',
    packaging:'Packaging',
    drug:'Drug | Drug',
    prescriptions:'Prescription | Prescriptions',
    prescription:'Prescription | Prescriptions',
    drugCreated: 'Drug created successfully',
    drugUpdated: 'Drug updated successfully',
    drugDeleted: 'Drug successfully deleted',
    prescriptionCreated: 'Prescription created successfully',
    prescriptionUpdated: 'Prescription updated successfully',
    prescriptionDeleted: 'Prescription successfully deleted',
    iSymbol:'Include Symbols',
    iNumber:'Include Numbers',
    iLoCase:'Include Lowercase Characters',
    iUpCase:'Include Uppercase Characters',
    iAmChar:'Include Ambiguous Characters',
    settings:"Settings",
    numberOfYear:"Number of years",
    smokedPerDay: "Number of cigarettes smoked per day",
    emptyUpload: "Reset",
    integer:'Type figures',
    reavivate:'Reactivate',
    nle_anle:'nle/anle',
    t1:'T1',
    nipt:'NIPT',
    biTest:'Bi-test',
    unknownDate:"Unknow date",
    value:"Value",
    glucose:"glucose",
    rcc:"RCC",
    tsh:"TSH",
    ft3:"FT3",
    ft4:"FT4",
    warning:"Warning",
    antiTpo:"ANTI TPO",
    emu:"EMU",
    infoSupported:"Supported information",
    pcr:"PCR Gonococcus | PCR Chlamydia",
    listOfPatientInstitution:"List of patient institution",
    searchPatient:'Search patient',
    preview:"Preview",
    back:"Back",
    change:"Change",
    unknownDateText:"If born towards ... Then set 01.January as date of birth.",
    street: "Street/Neighborhood",
    zipCode: "Zip code",
    parameter: "Parameters",
    date:"Date",
    logo:"Logo",
    familyStuation:"Family Situation",
    institutionConsultation:"Institution of consultation",
    tabac:"Tabaco",
    alcool:"Alcohol",
    nombreEnfant:"Number of children",
    enfants:"child | children",
    autres:"Other",
    marie:"Married",
    celibataire:"Single",
    signature:"Signature",
    informations:"Informatation | Informations",
    addConsultation:"Add consultation",
    print: "Print",
    infoConsultation:"Consultation data",
    infoPatient: "Personal data",
    infoAllergies: "Allergies",
    infoAntecedents: "Past medical history",
    copyrightText: '© 2019 All Rights Reserved.',
    loading: 'Loading...',
    home: 'Home',
    about: 'About',
    contact: 'Contact Us',
    login: 'Login',
    copyright_internal_footer : "All Rights Reserved. | Medsurlink by Medicasure",
    by_medicasure :"Made by Medicasure",
    connexion_formulaire :"Connect",
    register: 'Register',
    account: 'Account',
    dashboard: 'Dashboard',
    SouscripteurDashboard: 'Souscripteur Dashboard',
    logout: 'Logout',
    Medical_Administrative_Pathways: 'Medical-Administrative Pathways',
    Parcours_activités_Medecin_Contrôle: 'Course of activities Control doctor',
    Parcours_médicaux_et_financiers: 'Medical and Financial Pathways',
    Bilans: 'Reviews',
    Listsligne: "Listing of timelines",
    Historique_des_affiliations: "Membership History",
    sla: "Select an activity",
    addComplaints: "Add a new complaint",
    selectAffiliation: "Select affiliation",
    bilanGlobal: " Overall balance Insured",
    bilanFinancier: "My Financial Report",
    examsCom: "ADDITIONAL TESTS",
    paye: "Not Paid | Paid",
    date: "The start date was changed from | --- The end date was changed from | --- The date of signature has changed from ",
    to: "to | to",
    statut: "The payment status of the contract has changed from | The payment status has changed from",
    expired: "The expiration went from | The emergency level was raised from",
    info: "Membership Information",
    amount: "Amount",
    nomEtPrenom: "Name and surname",
    number: "Number",
    readMore: 'Read More',
    socialConnect: 'Get connected with us on social networks!',
    genericError: 'Something unexpected happened. Pleased try again later.',
    search: 'Search',
    email: 'Email',
    sexe: "Sex",
    password: 'Password',
    informationPatien: "Patient information",
    searchResults: 'Search results',
    currency: 'XAF',
    noResults: 'Nothing to display',
    cancel: 'Cancel',
    firstName: 'First Name',
    lastName: 'Name',
    phoneNumber: 'Phone Number',
    gender: 'Gender',
    decede: "Died",
    male: 'Male',
    female: 'Female',
    dob: 'Date of Birth',
    selectAvatar: 'Select Avatar',
    avatar: 'Avatar',
    passwordConfirm: 'Confirm Password',
    requiredField: 'This field is required',
    emailNotValid: 'E-mail must be valid',
    minCharacters: 'Min {n} characters',
    passwordsDontMatch: "Passwords don't match",
    add: 'Add',
    list: 'List',
    bought: 'Bought',
    sold: 'Sold',
    profile: 'Profile',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    guidelines: 'Guidelines',
    types: 'Type | Types',
    price: 'Price',
    yes: 'Yes',
    no: 'No',
    of: 'of',
    submit: 'Submit',
    users: 'User | Subscribers',
    createdAt: 'Created on',
    roles: 'Role | Roles',
    operations: 'Operation | Operations',
    name: 'Name',
    userCreated: 'User created successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User successfully deleted',
    rdvCreated: 'Appointment booking successfully',
    rdvUpdated: 'Appointment updated successfully',
    rdvDeleted: 'Appointment successfully deleted',
    partnerCreated: 'Partner created successfully',
    partnerUpdated: 'Partner updated successfully',
    partnerDeleted: 'Partner successfully deleted',
    countries: 'Country | Countries',
    rgpd: 'rgpd',
    partners: 'Partner | Partners',
    generalInfo: 'General Information',
    accountInfo: 'Account Information',
    denominations: 'Denomination | Denominations',
    address: 'Address',
    city: 'City',
    profession: 'Occupation',
    specialty: 'Specialty',
    workSite: 'Work Site',
    workSiteStreet: 'Work Site Street',
    workSiteCity: 'Work Site City',
    workSiteCountry: 'Work Site Country',
    orderNumber: 'Order Number',
    website: 'Website',
    socialNetwork: 'Social Network',
    gotMedicalSecretary: 'Do you have a medical secretary?',
    gotItTools: 'Do you have IT tools?',
    gotInternet: 'Do you have Internet access?',
    gotParkingSpace: 'Do you have parking space?',
    appointments: 'Appointment | Appointments',
    logoutSuccess: 'You have been logged out',
    previous: 'Previous',
    next: 'Next',
    subject: 'Subject',
    time: 'Time',
    emailHint: '(The appointment will be forwarded to you through this address)',
    whatsappNumber: 'WhatsApp Number',
    skype: 'Skype',
    enterAtLeastOneNumber: 'Enter at least a Whatsapp number, phone number or Skype ID',
    appointmentMade: 'Appointment made successfully',
    appointmentUpdated: 'Appointment updated successfully',
    appointmentCanceled: 'Appointment canceled successfully',
    appointmentDeleted: 'Appointment deleted successfully',
    dates: 'Date | Dates',
    status: 'Status',
    actions: 'Action | Actions',
    qCountries: 'Choose your countries',
    qTypes: 'Choose the interview type',
    qSubject: 'Subject of the interview',
    qTime1: '1st selected interview date and time',
    qTime2: '2nd selected interview date and time',
    qName: 'Your name',
    qEmail: 'Your email',
    contracts: 'Contract | Contracts',
    pickAtLeastTwoDates: 'Pick at least two (2) dates',
    pickOtherTimeSlot: 'Pick another time slot',
    bookAgain: 'Book another appointment',
    contractMade: 'Contract made successfully',
    contractSent: 'Contract sent successfully',
    contractUpdated: 'Contract updated successfully',
    contractDeleted: 'Contract deleted successfully',
    titles: 'Title | Titles',
    cities: 'City | Cities',
    nomSouscripteur: 'Subscriber name',
    paysSouscripteur: 'Subscriber country',
    villeSouscripteur: 'Subscriber city',
    phone1Souscripteur: 'Subscriber primary phone number',
    phone2Souscripteur: 'Subscriber secondary phone number',
    email1Souscripteur: 'Subscriber primary email address',
    email2Souscripteur: 'Subscriber secondary email address',
    typeSouscription: 'Subscription type',
    paysSouscription: 'Subscribtion country',
    sexeSouscripteur: 'Subscriber gender',
    nomPartenaire: 'Partner last name',
    prenomPartenaire: 'Partner first name',
    sexePartenaire: 'Partner gender',
    nomAffiliation: 'Affiliation name',
    sexeAffiliation: 'Affiliation gender',
    ageAffiliation: 'Affiliation age',
    paysAffiliation: 'Affiliation country',
    lieuEtablissement: 'Location of affiliation building',
    villeAffiliation: 'Affiliation city',
    annivAffiliation: 'Affiliation birthday',
    phone1Affiliation: 'Affiliate primary phone number',
    phone2Affiliation: 'Affiliate secondary phone number',
    phone1Contact: 'Affiliation primary phone number',
    phone2Contact: 'Affiliation secondary phone number',
    nomContact: 'Contact name',
    nomPractitioners: 'Practitionner name',
    nomPatient: 'Patient name',
    montantSouscription: 'Subscription amount',
    dateSignature: 'Date of signature',
    offres: 'Offer | Offers',
    offerList: {
        'one-shot': 'One shot',
        'annuelle': 'Annual'
    },
    permissions: 'Permission | Permissions',
    diagnosticselectionner: 'Select a diagnostic(s)',
    latest: 'Most recent',
    oldest: 'Oldest',
    none: 'None',
    downloadPdf: 'Download PDF',
    send: 'Send',
    resend: 'Resend',
    subscribers: 'Subscriber | Subscribers',
    nationality: 'Nationality',
    reset: 'Reset',
    subscriberCreated: 'Subscriber created successfully',
    subscriberUpdated: 'Subscriber updated successfully',
    subscriberDeleted: 'Subscriber successfully deleted',
    managers: 'Manager | Managers',
    civility: 'Civility',
    managerCreated: 'Manager created successfully',
    managerUpdated: 'Manager updated successfully',
    managerDeleted: 'Manager successfully deleted',
    patients: 'Patient | Patients',
    patientCreated: 'Patient created successfully',
    patientUpdated: 'Patient updated successfully',
    patientDeleted: 'Patient deleted successfully',
    professions: 'Profession | Professions',
    professionCreated: 'Profession created successfully',
    professionUpdated: 'Profession updated successfully',
    professionDeleted: 'Profession deleted successfully',
    specialties: 'Specialty | Specialties',
    specialtyCreated: 'Specialty created successfully',
    specialtyUpdated: 'Specialty updated successfully',
    specialtyDeleted: 'Specialty deleted successfully',
    controlDoctors: 'Control Doctor | Control Doctors',
    controlDoctorCreated: 'Control doctor created successfully',
    controlDoctorUpdated: 'Control doctor updated successfully',
    controlDoctorDeleted: 'Control doctor deleted successfully',
    institutions: 'Institution | Institutions',
    institutionCreated: 'Institution created successfully',
    institutionUpdated: 'Institution updated successfully',
    institutionDeleted: 'Institution deleted successfully',
    description: 'Description',
    practitioners: 'Practitioner | Practitioners',
    contributors: 'Contributor | Contributors',
    practitionerCreated: 'Practitioner created successfully',
    practitionerUpdated: 'Practitioner updated successfully',
    practitionerDeleted: 'Practitioner deleted successfully',
    userManagement: 'User Management',
    activiteManagement: 'Activity management',
    ajouterActivite: 'Ajouter une Activité',
    addAllergies: 'Ajouter une Allergie',
    ajouterFacture: 'Ajouter Une Facture',
    addConsul:'Ajouter Consultation Médecine Générale',
    editAffiliation: 'Modifier une Affiliation',
    addFollowUp: "Ajouter Un Suivi",
    medicalManagement: 'Medical File',
    consultations: 'Consultation | Consultations',
    obstetricConsultations: 'Obstetric Consultation | Obstetric Consultations',
    prenatalConsultations: 'Prenatal Consultation | Prenatal Consultations',
    generalConsultations: 'General Medicine Consultation | General Medicine Consultations',
    teleConsultations: 'Tele - Hetero Consultation | Tele - Hetero Consultations',
    cardiologyConsultations: 'Cardiology Consultation',
    dermatologyConsultations: 'Dermatology Consultation',
    endocrinologyConsultations: 'Endocrinology Consultation ',
    gastroenterologyConsultations: 'Gastroenterology Consultation ',
    geriatricsConsultations: 'Geriatrics Consultation ',
    hématologieConsultations: 'Hematology Consultation ',
    internalMedicineConsultations: 'Internal Medicine Consultation',
    nephrologyConsultations: 'Nephrology Consultation',
    neurologyConsultations: 'Neurology Consultation',
    ophthalmologyConsultations: 'Ophthalmology Consultation',
    oncologyConsultations: 'Oncology Consultation',
    earNoseThroatConsultations: 'Ear, Nose and Throat Consultation',
    pediatricsConsultations: 'Pediatrics Consultation',
    pneumologyConsultations: 'Pneumology Consultation',
    psychiatryConsultations: 'Psychiatry Consultation',
    rheumatologyConsultations: 'Rheumatology Consultation',
    stomatologyConsultations: 'Stomatology Consultation',
    teleConsultations: 'Tele - Hetero Consultation',
    treatments: 'Treatment | Treatments',
    treatmentCreated: 'Treatment created successfully',
    treatmentUpdated: 'Treatment updated successfully',
    treatmentDeleted: 'Treatment deleted successfully',
    allergies: 'Allergy | Allergies',
    allergyCreated: 'Allergy created successfully',
    allergyUpdated: 'Allergy updated successfully',
    allergyDeleted: 'Allergy deleted successfully',
    adminManagement: 'Administrative Management',
    medicalFiles: 'Medical File',
    medicalFileCreated: 'Medical file created successfully',
    medicalFileUpdated: 'Medical file updated successfully',
    medicalFileDeleted: 'Medical file deleted successfully',
    physicalExams: 'Physical Examiniation | Physical Examiniation(s)',
    physicalExamCreated: 'Physical examiniation created successfully',
    physicalExamUpdated: 'Physical examiniation updated successfully',
    physicalExamDeleted: 'Physical examiniation deleted successfully',
    complementaryExams: 'Work-up | Work-up(s)',
    complementaryExamCreated: 'Complementary examiniation created successfully',
    complementaryExamUpdated: 'Complementary examiniation updated successfully',
    complementaryExamDeleted: 'Complementary examiniation deleted successfully',
    references: 'Reference | References',
    affiliations: 'Affiliation | Affiliations',
    affiliationCreated: 'Affiliation created successfully',
    affiliationUpdated: 'Affiliation updated successfully',
    affiliationDeleted: 'Affiliation deleted successfully',
    startDate: 'Start date',
    endDate: 'End date',
    appointmentDate: 'Appointment date',
    appointmentReason: 'Appointment reason',
    creationDate: 'Creation date',
    pregnancyNumber: 'Pregnancy number',
    serology: 'Serology',
    bloodGroup: 'Blood group',
    familyStatus: 'Family status',
    addictions : 'Addiction | Addictions',
    transfusionAntecedent: 'Transfusion antecedent',
    riskFactor: 'Risk factor',
    obstetricConsultationCreated: 'Obstetric consultation created successfully',
    obstetricConsultationUpdated: 'Obstetric consultation updated successfully',
    obstetricConsultationDeleted: 'Obstetric consultation deleted successfully',
    ultrasounds: 'Ultrasound | Ultrasounds',
    ultrasoundCreated: 'Ultrasound created successfully',
    ultrasoundUpdated: 'Ultrasound updated successfully',
    ultrasoundDeleted: 'Ultrasound deleted successfully',
    amenorrheaWeek: 'Amenorrhea week',
    dpa: 'Expected date of delivery',
    prenatalConsultationCreated: 'Prenatal consultation created successfully',
    prenatalConsultationUpdated: 'Prenatal consultation updated successfully',
    prenatalConsultationDeleted: 'Prenatal consultation deleted successfully',
    typeOfConsultation:'Type of consultation',
    typeOfUltrasound:'Type of ultrasound',
    complaints:'Complaint | Complaints',
    antecedentSpouse:'Antecedent spouse',
    recommendations:'Recommendation | Recommendations',
    archievedAt:'Archieved at',
    passedAt:'Passed at',
    fileNumber: 'File number',
    hospitalisations: 'Hospitalization | Hospitalizations',
    hospitalisationCreated: 'Hospitalization created successfully',
    hospitalisationUpdated: 'Hospitalization updated successfully',
    hospitalisationDeleted: 'Hospitalization deleted successfully',
    entryDate: 'Entry date',
    exitDate: 'Exit date',
    clinicalHistory: 'Clinical history',
    lifestyle: 'Lifestyle',
    evolution: 'Evolution',
    conclusion: 'Diagnostic',
    avis: 'Opinion',
    exitTreatment: 'Exit treatment',
    nameAndFileNumber:"Name and file number",
    prenatals:"Prenatal | Prenatals",
    reasons : 'Presenting Complaint | Presenting complaints',
    reasonCreated: 'Reason created successfully',
    reasonUpdated: 'Reason updated successfully',
    reasonDeleted: 'Reason deleted successfully',
    reference: 'Reference',
    generalConsultationCreated: 'General medicine consultation created successfully',
    generalConsultationUpdated: 'General medicine consultation updated successfully',
    generalConsultationDeleted: 'General medicine consultation deleted successfully',
    anamnesis: 'History of presenting complaints',
    consultationDate: 'Consultation date',
    weight:"weight (Kg)",
    taSystolique:"systolic blood presure(mmHg)",
    taDiastolique:"diastolique blood presure (mmHg)",
    taSystoliqueL:"systolic blood presure(mmHg) left hand",
    taDiastoliqueL:"diastolique blood presure (mmHg) left hand",
    taSystoliqueD:"systolic blood presure(mmHg) right hand",
    taDiastoliqueD:"diastolique blood presure (mmHg) right hand",
    urineHeight:"fundal height",
    touchVaginal:"Vaginal examination",
    heartNoise:"Heart noise",
    obstetricParameters:"Obstetric parameter | Obstetric parameters",
    obstetricParameterCreated: 'Obstetric parameter created successfully',
    obstetricParameterUpdated: 'Obstetric parameter updated successfully',
    obstetricParameterDeleted: 'Obstetric parameter deleted successfully',
    remove: 'Remove',
    antecedents: 'Past medical history | past medical history',
    antecedentCreated: 'Past medical history created successfully',
    antecedentUpdated: 'Past medical history updated successfully',
    antecedentDeleted: 'Past medical history deleted successfully',
    exams: 'Exam | Exams',
    archieve:'Archieve',
    transmit:'Transmit',
    manuscritConsultations: 'External file',
    manuscritConsultationsCreated: 'External file  created successfully',
    manuscritConsultationsUpdated: 'External file updated successfully',
    manuscritConsultationsDeleted: 'External file  deleted successfully',
    manuscritConsultationArchieved:'External file  archived successfully',
    manuscritConsultationReactived:'External file  reactived successfully\'',
    manuscritConsultationTransmitted:'External file transmitted successfully\'',
    obstetricConsultationArchieved: 'Obstetric consultation archived successfully',
    obstetricConsultationTransmitted: 'Obstetric consultation transmitted successfully',
    prenatalConsultationArchieved:'Prenatal consultation archived successfully',
    prenatalConsultationTransmitted:'Prenantal consultation transmitted successfully',
    complementaryExamAdded: 'Complementary examiniation added successfully',
    ama: 'Ama',
    complementaryExamRemoved: 'Complementary examiniation removed successfully',
    physicalExamAdded: 'Physical examiniation added successfully',
    physicalExamRemoved: 'Physical examination removed successfully',
    kinesitherapyConsultationArchieved: 'Kynesitherapy consultation archived successfully',
    kinesitherapyConsultationTransmitted: 'Kynesitherapy consultation transmitted successfully',
    select:'Select',
    or:'Or',
    conclusions: 'Diagnostic | Diagnostics',
    conclusionCreated: 'Diagnostic created successfully',
    conclusionUpdated: 'Diagnostic updated successfully',
    conclusionDeleted: 'Diagnostic deleted successfully',
    commonParameters:"Common parameter | Common parameters",
    commonParameterCreated: 'Common parameter created successfully',
    commonParameterUpdated: 'Common parameter updated successfully',
    commonParameterDeleted: 'Common parameter deleted successfully',
    height: 'Height',
    results: 'Result | Results',
    resultCreated: 'Result created successfully',
    resultUpdated: 'Result updated successfully',
    resultDeleted: 'Result deleted successfully',
    uploadFile: 'Load a document (Result - Notebook - Photo - etc.) Max Size: 5Mo',
    laboratory: 'Laboratory',
    imagery: 'Imagery',
    labResults: 'Laboratory Result | Laboratory Results',
    imageryResults: 'Imagery Result | Imagery Results',
    currentTreatments: 'Current treatments',
    currentTreatmentsCreated: 'Treatment created successfully',
    currentTreatmentsUpdated: 'Treatment updated successfully',
    currentTreatmentsDeleted: 'Treatment deleted successfully',
    prescriptionDate: "Prescription date",
    fileManager: "File Manager",
    medecineConsultationArchieved: 'General medecine consultation archived successfully',
    medecineConsultationTransmitted: 'General medecine transmitted successfully',
    medecineConsultationReactived: 'General medecine reactivated successfully',
    obstetriqueConsultationReactived: 'General obstetric reactivated successfully',
    reslutArchieved: 'Result archived successfully',
    reslutTransmitted: 'Result transmitted successfully',
    hospitalisationArchieved: 'Hospitalisation archived successfully',
    hospitalisationTransmitted: 'Hospitalisation transmitted successfully',
    suggestTreatment:"Plan",
    ddr:"Last menstrual period",
    biometric:"Biometric",
    annex: "Annex",
    bmi:"Bmi (Kg/m²)",
    temperature:"Temperature (°C)",
    heartRate:"Heart rate (bpm)",
    respiratoryRate:"Respiratory rate (cpm)",
    sato2:"sato2 (%)",
    practionerDashboard:"Practioner dashboard",
    listPatientPerInstitution: "List of patients per institution",
    listPatient: "List of patients ",
    previousOperations: "Previous operation",
    action: "Action",
    listOfAffilaites:"List of new affiliates",
    listOfAffilaitesOld:"List of old affiliates",
    old:"Old",
    affiliated:"Affiliated",
    more: "More",
    obstetric: 'Obstetric',
    prenatal: 'Prenatal  ',
    general: 'General Medicine',
    cardiology: 'Cardiology ',
    dermatology: 'Dermatology ',
    endocrinology: 'Endocrinology  ',
    gastroenterology: 'Gastroenterology  ',
    geriatrics: 'Geriatrics  ',
    hématologie: 'Hematology  ',
    internalMedicine: 'Internal Medicine ',
    nephrology: 'Nephrology ',
    neurology: 'Neurology ',
    ophthalmology: 'Ophthalmology ',
    oncology: 'Oncology ',
    earNoseThroat: 'Ear, Nose and Throat ',
    pediatrics: 'Pediatrics ',
    pneumology: 'Pneumology ',
    psychiatry: 'Psychiatry ',
    rheumatology: 'Rheumatology ',
    stomatology: 'Stomatology ',
    tele: 'Tele - Hetero ',
    save:"Save",
    show:"Show",
    showCalendar: 'Calendar vue',
    showTable: 'Table vue',
    reprogrammed: 'Reprogramme',
    deleteConfirmation: 'Do you really want to delete it ?',
    cancelConfirmation: 'Do you really want to cancel it ?',
    followUp: 'Follow up',
    followUpPatient: 'Patient\'s follow up',
    followedUpCreated: 'Followed up made successfully',
    followedUpUpdated: 'Followed up updated successfully',
    followedUpDeleted: 'Followed up deleted successfully',
    state: 'etat | etats',
    pending: 'pending',
    ongoing: 'ongoing',
    closing: 'closing',
    manager: 'manager',
    isConsultantDoctor: "Will you be the consultant Doctor ?",
    medecin: 'medecin',
    fromMedicasure: 'From Medicasure',
    fromOthers: 'From others',
    preciseDoctorName: "Enter the doctor's name",
    preciseEtablissementrName: "Enter the institution's name",
    doctorName: "Doctor's name",
    medicaleFolder: "Medicale folder",
    moveQuestion: "Where do you want to move it to?",
    medicalAdvice: "Medical advice",
    objectAdvice: "Purpose of the advice request",
    doctorsAdvice: 'Select the doctor(s)',
    bindToPatientMedicalFolder: "Link to patient's medical folder",
    boundToPatientMedicalFolder: "Linked to patient's medical folder",
    notBoundToPatientMedicalFolder: "Not linked to patient's medical folder",
    medicalAdviceCreated: 'Medical advice made successfully',
    medicalAdviceUpdated: 'Medical advice updated successfully',
    medicalAdviceDeleted: 'Medical advice deleted successfully',
    adviceResponseSent: 'Medical advice response sent successfully',
    doctorsResponse: "Doctors' responses",
    noResponseForTheMoment: "Pas de réponse pour le moment",
    response: 'Response',
    responded: 'Responded',
    notResponded: 'Not responded',
    viewed: 'Viewed',
    notViewed: 'Not viewed',
    validateResponse: 'Validate the response',
    edited: 'Edited',
    from: 'from',
    validated: 'validated',
    noResponseOfMedicalAdviceValidated: "Pas de réponse d'avis medical validé",
    category: 'Category | Categories',
    noItem: "No item",
    noSearchResult: "No search result",
    todoList: "Todo list",
    ok: 'Ok',
    todoItemCreated: 'Todo item made successfully',
    todoItemDeleted: 'Todo item deleted successfully',
    addDescriptionHere: "Add description here",
    emergencyCode: "Emergency code",
    normal: 'Normal',
    urgent: 'Urgent',
    ultraUrgent: 'Ultra urgent',
    and: 'and',
    noItemToDisplay: 'No item to display',
    consult: 'Consult',
    sortBy: 'Sort by',
    kinesitherapie: 'kinesitherapie',
    kinesitherapyConsultations: 'Consultation Kinesitherapie',
    evaluationGlobale: 'Global evaluation',
    conduiteATenir: 'Conduct to be taken',
    impressionDiagnostique: 'Diagnostic printout',
    examensComplementaires: 'Complementary examination',
    conduite: 'Conduite',
    kinesitherapyConsultationsUpdated: 'Kinesitherapy updated successfull',
    partner: 'Partner',
    region: 'Region',
    personContact: 'Person to contact',
    Partners: 'Partners',
    addPatient: 'Add patient',
    canCreatePatient: 'You can not be able to add a patient',
    referenceDuPaiement: 'Paiement reference',
    Paie: 'Buy',
    acheterUneAffiliation: 'Buy a cim',
    code:"code",
    backtap:"Back",
    completeProfile: "Complete your Profil",
    PaiementSuccess:"Successful payment",
    welcomeToMedicasure:"Welcome to Medusrlink by Medicasure",
    paiementError:"We are sorry the payment was not successful, please try again.",
    errorTitle:"Payment error",
    mesPatient: "My patient",
    factureAvis: "Invoice advice",
    association: "Association",
    associations: "Associations",
    medecinPatient: "Medecin/patient",
    medecinreferent: "Referent Doctor",
    addAssociation: "Ajouter une Association",
    addControlDoctors: 'Ajouter Médecin Contrôle',
    addPractitioners: 'Ajouter un Practicien',
    addInstitution: 'Ajouter Un Etablissement',
    addPartners: 'Ajouter un Partenaire',
    medecinDossier: "Medecin patients",
    addMedicalAdvice: "Ajouter Avis Médicaux",
    payment: "Payment",
    motifPayment: "Prestation Payment",
    procederAuPaiement: "Process to payment",
    paymentManagement: "payments management",
    paymentPrestation: "Prestations payment",
    paymentCim: "CIM payments",
    payments:"Payments",
    paymentLink: "Payment link",
    souscripteur: "Suscriber",
    amountEURO:"Amount (EURO)",
    Editpayment: "Update payment",
    paymentDeleted: "Prestation invoice deleted",
    slack: "slack ID",
    AddPatientMessage: "Nous vous prions de renseingner les informations de vos patients pour qu'il puisse bénéficier immédiatement de leur prise en charge.",
    followUpSouscripteur: "Souscripteur CIM",
    nombreRestant:"CIM Restant",
    nombrePaye:"Paid CIM",
    rappel: "Rappel",
    gestionPatient: "Patients management",
    patientMedecinControl: "Patient & referent doctor",
    circonferenceAbdominal: "Abdominal circumference (cm)",
    circonferenceCranienne: "Cranial circumference (cm)",
    glycemie: "Blood sugar (mg/dL)",
    glycated: "Glycated hemoglobin (%)",
    cholestorol: "Total cholesterol (mg/dL)",
    hdl: "HDL (mg/dL)",
    ldl: "LDL (mg/dL)",
    tags: "Triglycerides (mg/dL)",
    examenclinique: "Clinic examination",
    diagnostic: "Diagnostic",
    cat: "CAT",
    rdv: "RDV",
    infosupplementaire: "additional info",
    generale:'General information',
    anthropometrie:'Anthropometry',
    signevitaux:'Vital signs',
    nutrition:'Nutrition',
    malnutrition:'Poor nutrition',
    deshydradation:'Dehydration',
    lipide:'Lipid',
    aucunedonnee:'No data',
    examencomplementaire: 'Complementary exams',
    saveAllergie: 'Save',
    Addcomptable: 'Add an accountant to an establishment',
    paymentsCim: 'Payment of CIM',
    voirSouscripteur: 'show subscriber',
    assistante: 'Assistante',
    listAssistante: 'Liste des assistantes',
    selectMontant:'Select amount',
    TrajetPatientComplet: 'COMPLETE PATIENT JOURNEYS',
    Trajet: 'Patient Journeys',
    trajetAMA: "History of medico-administrative activities (AMA)",
    activiteAdminIs: "Isolated Administrative Activities",
    diagnosticMedPrac: "Establishment of the diagnosis by the physician Practitioner",
    activiteAdminAuto: "Automatic Administrative Activities",
    activiteManAdmi: "Manual Administrative Activities",
    LigneTempsActivitéAMA: 'Activity timeline AMA',
    LigneTempsMedicofinanciere: 'Medical and financial timeline',
    EtatfinContrat: 'End of contract states (notifications)',
    infosouscription: 'Subscription information',
    ligneTempsMedFinan: 'Medical and financial timeline',
    Addligne: 'Add a timeline',
    Editligne:'Edit a timeline',
    Timeline: 'Timeline',
    TimelineCreated: 'Timeline created successfully',
    TimelineUpdated: 'Timeline updated successfully',
    TimelineDeleted: 'Timeline deleted successfully',
    TimelineSelect: 'Select timeline',
    commandecim: 'List of orders',
    mesAffilie: 'My affiliates',
    subscribe: 'Subscribe',
    debutAffiliation: 'Début Affiliation',
    finAffiliation: 'Fin Affiliation',
    lienParente: 'Lien Parenté',
    produit: 'Affiliation',
    affilie: 'Affilié',
    detailAffiliation: "Show the details",
    informationContrat: "Membership information",
    informationAffilie: "Informations de l'affilié",
    donneesAffiliation: "Membership Data",
    renouvelle: 'Renouveler',
    prolonger: 'Extend membership',
    resilierContrat: "Cancel",
    statusPaiement: "paiement statut",
    montantAffiliation: "Membership amount",
    mesfactures: "My bills",
    explication: "Affiliate via this form, your beneficiary patient to the offer",
    SouscripteurDashboard: 'My subscriptions',
    cimend: "Please credit your account in order to subscribe to a new affiliation",
    clickaffiliate: "Click on an affiliate to view details",
    medicalFile: "Medical File",
    urgence: "Emergency",
    paye_par_affilie: "Treatments will be paid for by the affiliate",
    gestionaffiliation: "Membership management",
    maintenance: "Dear visitors our platform is under maintenance",
    gestionmedical:"Medical managment",
    addvosaffilies:"add your affiliates",
    wait:"Please wait, you will be redirected shortly...",
    unitaire:"Unit amount",
    produits: "Products",
    numberpaid:"Number paid",
    numberstay:"Number remaining",
    consult:"Please consult your emails to have your access to your identifiers to connect and add your affiliates",
    patientinfo:"Patient information",
    personnecontact:"Contact person",
    nothing: "You have 0 affiliate",
    nodoctor:"No Doctor",
    canalmed: "Through which channel did you first hear about Medicasure ?",
    nooldpatient: "You dont have old patient",
    informationSouscripteur: "Subscriber Informations",
    voirrecu: "see the payment receipt",
    isloading:"You will be redirected to the payment interface, for a moment",
    moyenpaiement:"Please select the method by which you wish to make the payment.",
    creditcard:"Credit card",
    dejapaye:"You have already paid for this membership",
    validationPrix: "Validations prices",
    validation: "Exam Validations",
    addAffiliation:'add affiliation',
    Prospects: 'Prospects',
    notpossible: "You can no longer add a patient please purchase a new CIM",
    merci: "Thank you for choosing Medicasure, Payment completed successfully",
    dejaom: "Have you already validated the payment on the popup or type #150*50# and validate ?",
    verification: "Otherwise, the automatic verification will take place in : ",
    dejamomo: "Have you already validated the payment at *126#",
    visualiser: "See",
    addPec:'Assign a patient',
    addPecToInstitution:'Assign a patient to an institution',
    referentActivity: 'Activité Medécin Referent',
    detailsValidation: "Validation détails",
    ExamenPrixupdated: "Validation updated",
    Examenupdated: "Examens updated",
    suspendre: "Suspend",
    activeContrat: "Enabled",
    SubscriptionActive: "Membership activated",
    SubscriptionSuspend: "Membership suspended",
    ExamenUpdated: "Price updated successfully",
    validations: "Validations",
    PaiementPrestation: "Prestations",
    OldmedecinReferent: "Current doctor",
    NewmedecinReferent: "New doctor",
    transferer: "Transfert",
    infopersonnelle: "Personnel information",
    ListingPatientSansIntervention: "Patients without intervention",
    alerteCreated: "Alerte created successfully",
    alertDeleted: "Alerte deleted successfully",
    contactPersonne: "Contact person",
    diagnostic_complementaire: "Complementary Diagnostic",
    PermissionAssigned: "Permission assigned successfully",
    rgbac: "Roles and Permissions",
    FeatureAssigned: "Feature assigned successfully",
    userPermissions: "User permission"

}
